import { TablesStatus } from 'constants/tables';
import { CardPosition, ICardsMap } from 'types';
import { IChatMessage } from './chat';

export enum TableStates {
  TableLoading = 'TABLE_LOADING',
  TableOpened = 'GAME_OPENED',
  RoundStarted = 'ROUND_STARTED',
  BettingTimeStarted = 'BETTING_TIME_STARTED',
  BettingTimeFinished = 'BETTING_TIME_FINISHED',
  DrawStarted = 'DRAW_STARTED',
  DrawFinished = 'DRAW_FINISHED',
  ResultConfirmed = 'RESULT_CONFIRMED',
  RoundFinished = 'ROUND_FINISHED',
  RoundCanceled = 'ROUND_CANCELED',
}

export enum ResultBall {
  RED = 'RED',
  BLUE = 'BLUE',
  GOLD = 'GOLD',
  UNDEFINED = 'UNDEFINED',
}

export enum RouletteColorResult {
  RED = 'RED',
  BLACK = 'BLACK',
  GREEN = 'GREEN',
  UNDEFINED = 'UNDEFINED',
}

export const GameTypeNames: Record<number, string> = {
  1: 'Holi Bac',
  2: 'Holi HHH',
  3: 'Holi Roulette',
  4: 'Holi Classic Baccarat',
};

export enum GameType {
  BAC = 1,
  HHH = 2,
  ROULETTE = 3,
  CLASSIC_BAC = 4,
}

export enum ToastTypes {
  SUCCESS = 'Success',
  ERROR = 'Error',
  WARNING = 'Warning',
  DEFAULT = 'Default',
}

export type ToastValueType = {
  text: string;
  displayTime?: number;
};

export type DrawResultValue = '0' | '1' | '2';

export interface IDrawResult {
  id: string;
  value: DrawResultValue;
}

export type ToastItemType = {
  type?: ToastTypes;
  value: ToastValueType;
};

export interface IRound {
  timeValue?: number;
  isFinished: boolean;
  drawResults: string[] | number[];
  winner?: string | number;
  timerLeft?: number;
  startedAt?: string;
  drawStartedAt?: string;
  finishBettingTime?: string;
  finishDrawnDisplay?: string;
  finishWinDisplay?: string;

  cards?: ICardsMap | null;
  activeCardSlot?: CardPosition | null;
  hasUndefinedCard?: boolean;
  isBurnCardWindow?: boolean;
  cancelLastCardUsed?: boolean;
}

export interface IDealer {
  avatar: string;
  name: string;
  nickname: string;
  gameId: string;
}

export interface ITableCommon {
  id: string;
  game_id: string;
  auto_round: boolean;
  auto_draw: boolean;
  auto_confirm_result: boolean;
  betting_time: number;
  status: TablesStatus;
  game_type: number;
  displaying_drawn_result: number;
  displaying_win_result: number;
  rng: boolean;
}

export interface ITable extends ITableCommon {
  roundId?: string;
  dealer: IDealer;
  tableState: TableStates;
  statusText: string;
  round: IRound;
  closed?: {
    shiftManagerId?: string;
    verified?: boolean;
    isInProgress?: boolean;
    isClosed?: boolean;
    notification?: boolean;
  };
  changeResult?: {
    shiftManagerId?: string;
    verified?: boolean;
    isInProgress?: boolean;
    isChanged?: boolean;
  };
  toastItems: ToastItemType[];
  chatMessages: IChatMessage[];

  isShuffleRequired?: boolean;
}

export enum TimerTypes {
  bettingTime = 'bettingTime',
  drawingTime = 'drawingTime',
  displayingWin = 'displayingWin',
  displayingDrawn = 'displayingDrawn',
}
